<div class="bg-neutral-100 rounded-full px-sm inline-block">
  <div
    class="relative"
    libClickOutSide
    [insideSelector]="popover() ? '[data-range-filter-panel]' : ''"
    (clickOutside)="popover() && toggleRangeFilter.set(false)">
    <button
      #toggleButton
      type="button"
      class="bg-transparent flex items-center gap-x-sm"
      [class.cursor-text]="!hasToggleAction()"
      [class.cursor-pointer]="hasToggleAction()"
      [attr.aria-expanded]="hasToggleAction() ? toggleRangeFilter() : null"
      (click)="
        hasToggleAction() && toggleRangeFilter.set(!toggleRangeFilter())
      ">
      <div class="text-neutral-700 text-xs font-medium">
        @if (hasTranslatedLabel()) {
          {{ selectedRangeFilter().label }}
        } @else {
          {{
            'range_filter_options_{' + selectedRangeFilter().value + '}_label'
              | transloco
          }}
        }
      </div>

      @if (hasToggleAction()) {
        <svg
          width="16"
          height="16"
          class="size-4 text-neutral-500"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.2807 5.96875L8.93404 10.3154C8.4207 10.8288 7.5807 10.8288 7.06737 10.3154L2.7207 5.96875"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      }
    </button>

    @if (toggleRangeFilter()) {
      @if (popover()) {
        <!-- Portalled with Tippy so card edges and overflow never clip the list -->
        <div
          data-range-filter-anchor
          libTippyTooltip
          [contentTemplate]="optionsPanel"
          placement="bottom-end"
          trigger="manual"
          [showOnInit]="true"
          interactive
          [referenceElement]="toggleButton"
          [toolTipClass]="
            'bg-white shadow-xl rounded-lg py-lg px-md ' + dropdownClass()
          "
          [offset]="[0, 8]"
          class="absolute inset-0 pointer-events-none"
          aria-hidden="true"></div>
      } @else {
        <div
          libClickOutSide
          (clickOutside)="toggleRangeFilter.set(false)"
          class="top-[1.25rem] -start-2 z-2 absolute bg-white shadow-xl rounded-lg py-lg px-md w-[9rem]"
          [class]="dropdownClass()">
          <ng-container [ngTemplateOutlet]="optionsPanel" />
        </div>
      }
    }
  </div>
</div>

<ng-template #optionsPanel>
  <div
    data-range-filter-panel
    class="size-full overflow-y-auto pe-sm flex flex-col items-center gap-lg max-h-[9rem]">
    @for (option of rangeFilterOptions(); track option.value) {
      <button
        type="button"
        class="flex items-center justify-between bg-transparent text-start w-full"
        [class.text-primary-500]="selectedRangeFilter().value === option.value"
        [class.text-neutral-700]="selectedRangeFilter().value !== option.value"
        (click)="handleSelectRangeFilter(option)">
        <span class="text-xs font-medium inline-block">
          @if (hasTranslatedLabel()) {
            {{ option.label }}
          } @else {
            {{
              'range_filter_options_{' + option.value + '}_label' | transloco
            }}
          }
        </span>

        @if (selectedRangeFilter().value === option.value) {
          <svg
            width="16"
            height="12"
            class="do-not-transform w-4 h-3 text-primary-500"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 6.00004L5.99529 10.0001L14 2"
              stroke="currentColor"
              stroke-width="2.12016"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        }
      </button>
    }
  </div>
</ng-template>
